import React, { useState } from 'react';
import { callApi } from '../api';

const UyeDogrulama = () => {
    const [uyeKodu, setUyeKodu] = useState('');
    const [uyeBilgileri, setUyeBilgileri] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleDogrula = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);
        setUyeBilgileri(null);

        try {
            const response = await callApi(`/uyeler/check/${uyeKodu}`, 'GET');

            if (response.success && response.user) {
                setUyeBilgileri({
                    adSoyad: `${response.user.ad} ${response.user.soyad}`,
                    ogrenciNo: response.user.ogrenciNo,
                    telefon: response.user.telefon,
                    bolum: response.user.bolum
                });
            } else {
                setError(response.message || 'Girilen kodla eşleşen bir üye bulunamadı.');
            }
        } catch (err) {
            console.error("Doğrulama hatası:", err);
            setError("Doğrulama sırasında bir hata oluştu.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="uye-dogrulama-kapsayici">
            <h3>Üye Doğrulama</h3>
            <p>Üyenin kulüp kodunu girerek kaydını doğrulayın.</p>

            <form onSubmit={handleDogrula}>
                <div className="form-grubu">
                    <input
                        type="text"
                        value={uyeKodu}
                        onChange={(e) => setUyeKodu(e.target.value)}
                        placeholder="Üye Kodunu Girin"
                        required
                    />
                </div>
                <button type="submit" className="primary-button" disabled={isLoading}>
                    {isLoading ? 'Doğrulanıyor...' : 'Doğrula'}
                </button>
            </form>

            {uyeBilgileri && (
                <div className="dogrulama-sonucu-kutusu">
                    <h4>✅ Üye Kaydı Bulundu</h4>
                    <p><strong>Ad Soyad:</strong> {uyeBilgileri.adSoyad}</p>
                    <p><strong>Öğrenci No:</strong> {uyeBilgileri.ogrenciNo}</p>
                    <p><strong>Telefon:</strong> {uyeBilgileri.telefon}</p>
                    <p><strong>Bölüm:</strong> {uyeBilgileri.bolum || 'Belirtilmemiş'}</p>
                </div>
            )}

            {error && <p className="error-message">{error}</p>}
        </div>
    );
};

export default UyeDogrulama;